module.exports = __webpack_public_path__ + "img/pic1.a0015a09.png";